import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './IndustryChallengesAndSolutions.scss';



const IndustryChallengesAndSolutions = ({industryChallengesAndSolutionsContent}) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false,
      offset: 100
    });
  }, []);

  return (
    <section className="industry-challenges-solutions-section container">
      <div className="column" data-aos="fade-right" data-aos-delay="100">
        <h2 data-aos="fade-up" data-aos-delay="200">{industryChallengesAndSolutionsContent.challengesTitle}</h2>
        {industryChallengesAndSolutionsContent.challenges.map((item, idx) => (
          <div 
            className="card" 
            key={idx}
            data-aos="fade-up"
            data-aos-delay={300 + (idx * 100)}
          >
            <img 
              className="icon" 
              src={item.icon} 
              alt="Industry Challenge Icon"
              data-aos="zoom-in"
              data-aos-delay={400 + (idx * 100)}
            />
            <div className="card-content">
              <h3 className="card-title">{item.title}</h3>
              <p className="card-desc">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="column" data-aos="fade-left" data-aos-delay="100">
        <h2 data-aos="fade-up" data-aos-delay="200">{industryChallengesAndSolutionsContent.solutionsTitle}</h2>
        {industryChallengesAndSolutionsContent.solutions.map((item, idx) => (
          <div 
            className="card" 
            key={idx}
            data-aos="fade-up"
            data-aos-delay={300 + (idx * 100)}
          >
            <img 
              className="icon" 
              src={item.icon} 
              alt="Our Solution Icon"
              data-aos="zoom-in"
              data-aos-delay={400 + (idx * 100)}
            />
            <div className="card-content">
              <h3 className="card-title">{item.title}</h3>
              <p className="card-desc">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default IndustryChallengesAndSolutions; 